<template>
  <div>
    <div class="page-header header-filter header-tiny bg-tri-1">
      <b-container>
        <b-row align-h="center">
          <h1>Players</h1>
        </b-row>
      </b-container>
    </div>
    <div>
      <b-container>
        <b-row v-for="item in players" :key="item.id">
          <b-col>
            <h3>{{ item.name }}</h3>
            <ul>
              <li v-for="(value, prop) in item" :key="prop">
                {{ prop }}: {{ value }}
              </li>
            </ul>
            <hr />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapState, mapActions } = createNamespacedHelpers("admin/players");

export default {
  name: "Players",
  created() {
    this.considerLoad();
  },
  computed: {
    ...mapState(["players"]),
    isAuthenticated() {
      return this.$store.state.session.player !== null;
    }
  },
  methods: {
    ...mapActions(["loadPlayers"]),
    considerLoad() {
      console.log(`considerLoad(). Player: ${JSON.stringify(this.$store.state.session.player)}. Player len: ${this.players.length}.`);
      if (this.$store.state.session.player && this.players.length == 0) {
        this.loadPlayers();
      }
    },
  },
  watch: {
    isAuthenticated(val, oldVal) {
      console.log(`Watch isAuthed: ${val} (old: ${oldVal}).`);
      this.considerLoad();
    }
  },
};
</script>

<style scoped>
</style>